import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineCloudDownload } from "react-icons/ai";
import config from "../../config";
import { useLanguage } from "../../Context";
import { IoMdEye, IoMdCalendar } from "react-icons/io";

export default function Book() {
  const [items, setItems] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { language } = useLanguage();

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=7&categoryid=5&subcategory=0&limitCount=5&lang=${language}`
    )
      .then((response) => response.json())
      .then((items) => {
        setItems(items);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, [language]);

  // Loader before data is loaded
  if (isLoading) {
    return (
      <div className="max-container-width p-0">
        <div className="d-flex flex-column flex-lg-row">
          <div className="col-lg-7 placeholder-glow d-flex flex-column flex-md-row-reverse border-dotted">
            <div className="col-lg-8 px-3">
              <span
                className="placeholder col-7 mb-3"
                style={{ height: "2rem" }}
              />
              {[...Array(7)].map((_, index) => (
                <span key={index} className="placeholder col-12 mb-3" />
              ))}
              <a
                className="btn disabled placeholder me-auto"
                aria-disabled="true"
                style={{ backgroundColor: "#024c67", width: "9rem" }}
              />
            </div>
            <div className="col-lg-4 mx-auto placeholder bg-secondary"></div>
          </div>
          <div className="col-lg-5 p-3 placeholder-glow">
            {[...Array(2)].map((_, index) => (
              <div key={index} className="d-flex py-3 border-bottom-dotted">
                <div className="col-3 placeholder bg-secondary"></div>
                <div className="col-9 px-3">
                  <span
                    className="placeholder col-8 mb-3"
                    style={{ height: "1.5rem" }}
                  />
                  <span className="placeholder col-12 mb-3" />
                  <span className="placeholder col-12 mb-3" />
                  <span className="placeholder col-12 mb-4" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // error if data is not fetched
  if (error) {
    return (
      <div className="max-container-width pt-4 pb-3">
        <p className="alert alert-danger" role="alert" dir="ltr">
          Something went wrong: {error.message}
        </p>
      </div>
    );
  }

  const lastArrayElement = items.slice(-1);
  const latestBook = lastArrayElement.map((book) => (
    <div
      key={book.id}
      className="col-lg-7 d-flex flex-column flex-md-row-reverse border-dotted"
    >
      <div className="col-lg-8 px-3">
        <h3>{book.Title}</h3>
        <p className="latest-limit-text">{book.ShortDesc}</p>
        <a
          href={book.FileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn primary-bg-blue text-white icon-links mb-3"
        >
          <AiOutlineCloudDownload
            className="ms-2"
            style={{ width: "1.3rem", height: "1.3rem" }}
          />
          دانلود کتاب
        </a>
      </div>
      <img
        src={book.ImageUrl}
        alt=""
        className="col-lg-4 object-fit-cover mx-auto"
        style={{ maxWidth: "16rem", maxHeight: "23rem" }}
      />
    </div>
  ));

  items.pop();

  return (
    <div className="d-flex flex-column flex-lg-row">
      {latestBook}
      <div className="col-lg-5 p-3" id="publication-scroll">
        {items.map((book) => (
          <Link
            to={`/${book.CategoryE}/${book.SubCategory}/${book.id}`}
            key={book.id}
            className="d-flex py-3 primary-text-blue border-bottom-dotted"
          >
            <img
              src={book.ImageUrl}
              alt=""
              className="col-3 object-fit-cover"
              style={{ width: "8rem", height: "10rem" }}
            />
            <div className="col-9 px-3">
              <h4>{book.Title}</h4>
              <p className="limit-text">{book.ShortDesc}</p>
              <div className="d-flex align-items-center">
                <div className="d-flex align-items-center ms-2">
                  <IoMdCalendar className="ms-1" /> {book.PostDate}
                </div>
                <div className="d-flex align-items-center">
                  <IoMdEye className="ms-1" /> {book.contentViews}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
